<template>
  <div
    class="position-relative d-flex flex-column align-items-center w-100 mobile-moment"
    :class="[ data.class, data.open ? 'pointer-events-none' : '', isVisible ? 'visible' : '' ]"
  >

    <div class="bubble" :class="{ open: isOpen }">
      <moment-bubble :open="isOpen" :h-factor="hFactor" :h-mod="hMod" @prog="val => txtAlpha = val" v-if="loadBubble"/>
      <div class="dots">
        <div class="dot"></div>
      </div>

      <div
        class="position-absolute d-flex align-items-center w-100 moment-content"
        :style="{ height: (hMod * hFactor) + 'px', opacity: txtAlpha }"
      >
        <div class="d-flex w-100 moment-content-inner">
          <img
            :src="require(`@/assets/img/moments/${data.img}`)"
            :alt="data.txt"
            :style="{ height: (baseImgHeight * hFactor) + 'px', width: (baseImgHeight * hFactor) + 'px' }"
            class="align-self-center moment-img"
            ref="img"
          >
          <span class="adobe-italic col pl-3 pr-0 moment-txt" v-html="data.txt" ref="txt"></span>
        </div>
      </div>

    </div>

    <span class="adobe-clean-black desc position-absolute w-100 text-center"
          :style="[ bg.match(/^#(?:fafafa|f{3,6})$/i) ? { color: accent } : {} ]">MOBILE MOMENT</span>

  </div>
</template>

<script>
  import MomentBubble from '@/components/svg/MomentBubble'
  import ContentMixin from '@/components/report/mixins/ContentMixin'
  import StateMixin from '@/components/report/mixins/StateMixin'

  export default {
    name: 'MobileMoment',
    mixins: [ ContentMixin, StateMixin ],
    data () {
      return {
        isOpen: this.data.open,
        isVisible: !this.data.open,
        hFactor: 1,
        loadBubble: false,
        txtAlpha: 0
      }
    },
    computed: {
      baseImgHeight () {
        return this.winW < 768 ? 63 : 83
      },
      hMod () {
        return this.winW < 768 ? 100 : 90
      }
    },
    mounted () {
      setTimeout( () => {
        this.hFactor = Math.max( 1, (this.$refs.txt.clientHeight * 0.95 / this.$refs.img.clientHeight) )
        this.$nextTick( () => {
          this.loadBubble = true
        } )
      }, 100 )
      let wp = new window.Waypoint( {
        element: this.$el,
        handler: () => {
          this.isVisible = true
          this.isOpen = true
          wp.destroy()
        },
        offset: '85%'
      } )
    },
    components: { MomentBubble }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/the_goods";

  @keyframes dotFade {
    0% { background : rgba(0, 0, 0, 1) }
    100% { background : rgba(0, 0, 0, 0.2) }
  }

  $speed : 0.7s;

  .mobile-moment {
    opacity    : 0;
    transition : opacity 500ms cubic-bezier(0.645, 0.000, 0.355, 1.000);

    &.visible {
      opacity : 1;
    }
  }

  .dot {
    top : 31%;
    @include screen-md-lg-xl {
      top : 29%;
    }
    &, &::before, &::after {
      position      : absolute;
      width         : viewport-scale(8);
      height        : viewport-scale(8);
      background    : rgba(0, 0, 0, 1);
      border-radius : 100%;
      left          : calc(50% - #{viewport-scale(4)});
      animation     : dotFade $speed linear ($speed / 2) infinite alternate;

      @include screen-md-lg-xl {
        width  : 12px;
        height : 12px;
        left   : calc(50% - 6px);
      }
    }
    &::before, &::after {
      content : '';
      top     : 0;
    }
    &::before {
      left            : calc(50% - #{viewport-scale(16)});
      animation-delay : 0s;

      @include screen-md-lg-xl {
        left : calc(50% - 24px);
      }
    }
    &::after {
      left            : calc(50% + #{viewport-scale(8)});
      animation-delay : $speed;

      @include screen-md-lg-xl {
        left : calc(50% + 12px);
      }
    }
  }

  .dot, .desc {
    transition : opacity 0.5s 0.65s;
  }

  .desc {
    color            : #fff; // overridden inline if over a white background
    font-size        : viewport-scale(12);
    letter-spacing   : 0.1666em;
    opacity          : 0;
    transition-delay : 0s;
    top              : 100%;
    left             : 0;

    @include screen-md-lg-xl {
      font-size : rem(12);
    }
  }

  .moment-content {
    padding    : 0 0.7rem;
    transition : opacity 0.5s;
    max-width  : 320px;
    bottom     : 14px;
    left       : 50%;
    transform  : translateX(-50%);

    @include screen-md-lg-xl {
      max-width : 450px;
      bottom    : -12px;
      padding   : 0 1.6rem 0 0.7rem;
      transform : translate(-50%, -50%);
    }
  }

  .moment-content-inner {
    align-items : flex-start;

    @include screen-md-lg-xl {
      align-items : center;
    }
  }

  .moment-img {
    width  : viewport-scale(63);
    height : viewport-scale(63);

    @include screen-md-lg-xl {
      width  : 83px;
      height : 83px;
    }
  }

  .moment-txt {
    font-size   : rem(16);
    line-height : rem(20);
    color       : #202020;
  }

  .bubble {
    width  : 61px;
    height : 45px; // to appease the IE11 gods...

    @include screen-md-lg-xl {
      width  : 96px;
      height : 60.22px; // to appease the IE11 gods...
    }

    &.open {
      + .desc {
        opacity          : 1;
        transition-delay : 0.55s;
      }
      .dot {
        opacity          : 0;
        transition-delay : 0s;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/content/MobileMoment.vue